import React, { useState } from 'react';
import axios from 'axios';

const AddJob = () => {
    const [job, setJob] = useState({
        title: '',
        company: '',
        location: '',
        description: '',
        link: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setJob({ ...job, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/jobs/`, job);
            alert(response.data.message);
            setJob({ title: '', company: '', location: '', description: '', link: '' });
        } catch (error) {
            alert('Failed to add job');
        }
    };

    return (
        <div className="container mt-5">
            <h1 className="text-center mb-4">Add a Job</h1>
            <form onSubmit={handleSubmit} className="shadow p-4">
                <div className="mb-3">
                    <label className="form-label">Job Title</label>
                    <input type="text" name="title" className="form-control" value={job.title} onChange={handleChange} required />
                </div>
                <div className="mb-3">
                    <label className="form-label">Company</label>
                    <input type="text" name="company" className="form-control" value={job.company} onChange={handleChange} required />
                </div>
                <div className="mb-3">
                    <label className="form-label">Location</label>
                    <input type="text" name="location" className="form-control" value={job.location} onChange={handleChange} required />
                </div>
                <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea name="description" className="form-control" value={job.description} onChange={handleChange} required />
                </div>
                <div className="mb-3">
                    <label className="form-label">Application Link</label>
                    <input type="url" name="link" className="form-control" value={job.link} onChange={handleChange} required />
                </div>
                <button type="submit" className="btn btn-primary">Add Job</button>
            </form>
        </div>
    );
};

export default AddJob;
